exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resultList__item[data-v-5ec10f13]{border-bottom:1px solid #ededed}.resultList__body[data-v-5ec10f13]{overflow:hidden;padding:24px 0 16px}.resultList__title[data-v-5ec10f13]{margin:0 0 8px;font-weight:700;font-size:17px;line-height:25px;color:#32373f}.resultList__text[data-v-5ec10f13]{font-weight:400;font-size:13px;line-height:21px;text-align:justify;color:#656d78;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}.resultList__text--open[data-v-5ec10f13]{display:block}.resultList__icon[data-v-5ec10f13]{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ec10f13","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/YearLuck/y2021/resultList.vue
// module id = mXPx
// module chunks = 0